import React, { Component } from 'react'

import loading from './loading.gif'

const Spinner = () => {

    return (
      <div className='text-center'>
        <img src={loading} alt="loading" />
      </div>
    )

}

export default Spinner

// https://www.aljazeera.com/wp-content/uploads/2026/07/2026-07-03T223244Z_1340742998_UP1EM731QMIPH_RTRMADP_3_SOCCER-WORLDCUP-ARG-CPV-1783118040.jpg?resize=1920%2C1440